import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import React from "react";
import { Footer } from "../../components/Footer";
import { Nav } from "../../components/common/FrontendNav";
import { PostOrPage } from "@tryghost/content-api";
import { StaticGhostPage } from "../../components/StaticGhostPage";
import getPage from "../../news/getPage";
import { useTranslation } from "next-i18next";
import Head from "next/head";
import { getSidebar } from "@/data/news";
import { setGhostCacheHeader } from "@/helper/cacheHeaders";

export async function getServerSideProps(context: any) {
  const { res } = context;
  setGhostCacheHeader(res);
  const page = await getPage(
    context.locale === "de"
      ? "674efd0d3b77bb0001b5d2da"
      : "6abbcb52039d540001caf18d",
  );
  const sidebar = await getSidebar(context.locale);
  return {
    props: {
      page,
      sidebar,
      ...(await serverSideTranslations(context.locale)),
    },
  };
}

interface NewsPageProps {
  page: PostOrPage;
  sidebar: PostOrPage;
}
export default function NewsPage({ page, sidebar }: NewsPageProps) {
  const { t } = useTranslation();
  return (
    <>
      <Head>
        <title>{`${t(
          "Table_Tennis",
        )} Bundesliga - TTBL - Move Your Sport`}</title>
      </Head>
      <div>
        <Nav />
        <StaticGhostPage page={page} sidebar={sidebar} />
        <Footer />
      </div>
    </>
  );
}
